import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Heading, Box } from '@hover/blueprint';
import { SharedHero } from '@hover/shared-components';
import { Layout, ReadyToSeeWithImage } from '../../v2/components/common';

import {
  HeroButtons,
  Steps,
  RoofingCalculator,
  RoofingMaterials,
  FAQ,
} from '../../v2/components/how-to-measure-a-roof';
import { usePageViewTracking } from '../../utils/trackPageView';

const HowToMeasureARoof: React.FC = () => {
  usePageViewTracking('how-to-measure-a-roof');
  return (
    <Layout title="How to measure a roof" buttonType="CHAT_WITH_A_REP">
      <SharedHero
        bg="brandNavy.100"
        haveContentChildren
        heading="How to measure a roof"
        body="A step-by-step guide to measure a roof’s square footage and pitch so you can estimate shingle quantity and roof replacement cost"
        desktopImage={
          <StaticImage
            loading="eager"
            placeholder="blurred"
            alt="How to measure a roof hero"
            src="../../v2/assets/images/how_to_measure_roof_hero_desktop.png"
          />
        }
        mobileAndTabletImage={
          <StaticImage
            loading="eager"
            placeholder="blurred"
            alt="How to measure a roof hero"
            src="../../v2/assets/images/how_to_measure_roof_hero_tablet.png"
          />
        }
        contentChildren={<HeroButtons />}
        page="how-to-measure-a-roof"
      />
      <Box px={{ base: 500, tablet: '56px' }} maxW="1100px" mb="56px">
        <Heading
          as="p"
          isDisplay
          textAlign={{ base: 'center', tablet: 'center' }}
          size={{ base: 300, tablet: 500 }}
        >
          Reliable roof measurements make projects go smoothly and stay on
          budget. Whether you’re a contractor training a new employee or a
          homeowner budgeting for a new roof, use this guide to accurately
          measure and calculate roof squares for any roof.
        </Heading>
      </Box>
      <Steps />
      <RoofingCalculator />
      <RoofingMaterials />
      <FAQ />
      <ReadyToSeeWithImage
        bg="brandNavy.500"
        image={
          <StaticImage
            placeholder="blurred"
            alt="Measure roof ready to see"
            src="../../v2/assets/images/measure_roof_ready_to_see.png"
          />
        }
        body="Get a free 3D model of your home today."
        headingColor="neutral.0"
        bodyColor="neutral.0"
        buttonProps={{
          colorScheme: 'brandNavy',
          variant: 'inverted',
        }}
      />
    </Layout>
  );
};

export default HowToMeasureARoof;
